import createStorage from './createStorage'

// Account storage, must be cleaned after log out
// If you need storage which can be persisted between sessions, create another wrapper with different prefix
export const AccountStorage = createStorage('bka')
